import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { defaultPrimitive } from "src/modules/pe-landing-module/data/interfaces"
import { LogoPrimitive } from "../../primitive"
import { ICardFieldProps } from "../cards/CardField"

/* Protopia Ecosystem component */
const CardFieldLogo = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props

    useEffect(() => { 
        addCSSClass(
            `landing-card-field-logo-${section.id + "-" + value?.id}`,
            `.landing-card-field-logo-${section.id + "-" + value?.id} {
                
            } 
            `
        )
        return () => removeCSSClass(`landing-card-field-logo-${section.id + "-" + value?.id}`)
    }, []) 

    const primitive = {
        ...defaultPrimitive(),
        ...field,
        ...value,
        data: {
            ...field.data,
            src: value.data,
        },
        style: { ...field.style, ...value.style },
        className: (field.className || "") + " " + (value.style || "") + " medallion-padder",
        id: section.id + "-" + value?.id, 
    }
    return <div 
        className={`landing-card-field landing-card-field-logo ${value.className || ""}`} 
        style={{ ...field.style, ...value.style }} 
        data-card-field-id={i}
        card-field-section-id={section.id}
    > 
        <LogoPrimitive primitive={ primitive } /> 
    </div>
}
export default CardFieldLogo